import React from 'react';
import TeamBadge from '@/components/TeamBadge';

interface ShipmentTablePackageBadgeProps {
  count?: number;
}

const ShipmentTablePackageBadge: React.FC<ShipmentTablePackageBadgeProps> = ({
  count,
}) => {
  if (!count || count <= 1) return null;
  return <TeamBadge text={`${count} packages`} Truncate={false} />;
};

export default ShipmentTablePackageBadge;
